import { render, staticRenderFns } from "./SuppliesConfig.vue?vue&type=template&id=253d072b&"
import script from "./SuppliesConfig.vue?vue&type=script&lang=js&"
export * from "./SuppliesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports